import React, {
  memo, useCallback, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  ButtonGroup, IconButton, InputAdornment, Menu, MenuItem,
} from '@mui/material';
// eslint-disable-next-line import/no-cycle
import EditorControls from '../editorControls';

const AVAILABLEUNITS = [
  '%',
  'px',
  'em',
  'rem',
];

function WidthInput({
  value, onChange, label, description,
}) {
  const numberValue = useMemo(
    () => {
      if (value === null) return null;
      const v = parseFloat(value);
      if (Number.isNaN(v)) return null;
      return v;
    },
    [value],
  );
  const unitValue = useMemo(
    () => {
      if (numberValue === null) return null;
      const uv = value.replace(String(numberValue), '');
      if (AVAILABLEUNITS.includes(uv)) return uv;
      return null;
    },
    [numberValue, value],
  );
  const onChangeValue = useCallback(
    (e, v) => onChange(e, `${v}${unitValue}`),
    [onChange, unitValue],
  );
  const onChangeUnitValue = useCallback(
    (e, v) => onChange(e, `${numberValue}${v}`),
    [numberValue, onChange],
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpened = !!anchorEl;
  const handleClick = useCallback((e) => {
    setAnchorEl(e.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <EditorControls.NumerInput
        label={label}
        description={description}
        value={numberValue}
        onChange={onChangeValue}
        precision={2}
        endAdornment={(
          <InputAdornment position="end">
            <ButtonGroup size="small" variant="outlined">
              <IconButton onClick={handleClick} size="small">
                {unitValue || (
                  <FontAwesomeIcon icon={faCaretDown} />
                )}
              </IconButton>
              <IconButton
                onClick={(e) => onChange(e, null)}
                size="small"
              >
                <FontAwesomeIcon icon={faTimes} />
              </IconButton>
            </ButtonGroup>
          </InputAdornment>
      )}
      />
      <Menu
        anchorEl={anchorEl}
        open={menuOpened}
        onClose={handleClose}
      >
        {AVAILABLEUNITS.map((au) => (
          <MenuItem onClick={(e) => onChangeUnitValue(e, au)}>
            {au}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

WidthInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
};

WidthInput.defaultProps = {
  value: null,
  label: null,
  description: '',
};

export default memo(WidthInput);
